(function($) {
  'use strict';

  $(document).ready(function() {
    var $block = $('.faq-accordions');
    if (!$block.length) return;

    var $pills = $block.find('.pills .pill');
    var $sections = $block.find('.sections .section');

    // Pill click: smooth scroll to section
    $pills.on('click', function() {
      var target = $(this).data('target');
      var $target = $('#' + target);
      if (!$target.length) return;

      $pills.removeClass('active');
      $(this).addClass('active');

      $('html, body').animate({
        scrollTop: $target.offset().top - 150
      }, 400);
    });

    // Update active pill on scroll via IntersectionObserver
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            $pills.removeClass('active');
            $pills.filter('[data-target="' + id + '"]').addClass('active');
          }
        });
      }, {
        root: null,
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0
      });

      $sections.each(function() {
        observer.observe(this);
      });
    }
  });

})(jQuery);
